import { useEffect } from "react";

const SITE = "https://hexagoneor.com";

export default function Seo({ title, description, path = "/" }) {
    useEffect(() => {
        document.title = title;
        const meta = document.querySelector('meta[name="description"]');
        if (meta) meta.setAttribute("content", description);
        let link = document.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            document.head.appendChild(link);
        }
        link.setAttribute("href", `${SITE}${path}`);
    }, [title, description, path]);
    return null;
}
